const firebaseConfig = {
  apiKey: "AIzaSyD5k9zZIf5D43x7PgaiM5anfl41_06PRWk",
  authDomain: "healthcare-therapy.firebaseapp.com",
  projectId: "healthcare-therapy",
  storageBucket: "healthcare-therapy.appspot.com",
  messagingSenderId: "174001840624",
  appId: "1:174001840624:web:4c4292cf083eeacb5c3d35",
};

export default firebaseConfig;
